const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://9zj1ja5mlc.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://zm2a6iytbe.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://hlz7j0hlnj.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.staging.teck.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.teck.forwoodsafety.com',
    WEBSOCKET: 'wss://hop65qwi7i.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;